export default Object.freeze({
  name: 'Ilvaco',
  version: '1.0.1',
  api_url: (`${process.env.VUE_APP_API_URI || '/api/'}/`).replace(/\/+$/, ''),
  helpers: {},
  ENV_MODE: process.env.VUE_APP_MODE || 'production',
});
